module.exports = __webpack_public_path__ + "img/logo.ec45ac57.png";